"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Header = void 0;
const settings_1 = require("./settings");
require("./header.scss");
class Header {
    constructor(className) {
        this.headerText = {
            title: 'RSS Puzzle Game',
            subtitle: 'Assemble sentences from jumbled words. Put the given words in the right order'
        };
        this.headerHTML = document.createElement('header');
        this.headerHTML.classList.add(className);
        this.menu = new settings_1.SettingsUI('settings');
    }
    static createTitle(title, hElement) {
        const headerTitle = hElement === 'main-title' ? document.createElement('h1') : document.createElement('p');
        headerTitle.classList.add(hElement);
        headerTitle.innerText = title;
        return headerTitle;
    }
    render(greetingString) {
        const menuContainer = document.createElement('div');
        const startContainer = document.createElement('div');
        const title = Header.createTitle(this.headerText.title, 'main-title');
        const discription = Header.createTitle(this.headerText.subtitle, 'discription');
        menuContainer.classList.add('menu-container');
        startContainer.classList.add('start-container');
        const menu = this.menu.render();
        const greetingHTML = document.createElement('p');
        greetingHTML.innerText = `Player: ${greetingString}`;
        menuContainer.append(menu);
        menuContainer.append(greetingHTML);
        menuContainer.append(menu);
        this.headerHTML.append(menuContainer);
        this.headerHTML.append(startContainer);
        this.headerHTML.append(title);
        this.headerHTML.append(discription);
        return this.headerHTML;
    }
}
exports.Header = Header;
